import { render } from "./InLaysBenefits.vue?vue&type=template&id=71d1e71a"
import script from "./InLaysBenefits.vue?vue&type=script&lang=js"
export * from "./InLaysBenefits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__